import { render, staticRenderFns } from "./report2.vue?vue&type=template&id=10f5aaaa&scoped=true&"
import script from "./report2.vue?vue&type=script&lang=js&"
export * from "./report2.vue?vue&type=script&lang=js&"
import style0 from "./report2.vue?vue&type=style&index=0&id=10f5aaaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f5aaaa",
  null
  
)

export default component.exports